<modal-panel class="modal-panel filter-panel" title="Filter" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields">
      <mat-grid-list [cols]="isSmall ? 1 : 2" gutterSize="20px" rowHeight="85">
        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Travel Types</mat-label>
            <mat-select formControlName="TravelTypeIds" multiple>
              <mat-select-trigger>
                {{ getTravelTypeNameById(form.controls.TravelTypeIds.value[0]) || '' }}
                @if ((form.controls.TravelTypeIds.value.length || 0) > 1) {
                  <span>
                    (+{{ (form.controls.TravelTypeIds.value.length || 0) - 1 }} {{ form.controls.TravelTypeIds.value.length === 2 ? 'other' : 'others' }})
                  </span>
                }
              </mat-select-trigger>

              <mat-option selectAll [allValues]="allTravelTypes()">Select all</mat-option>
              @for (item of travelTypes(); track $index) {
                <mat-option [value]="item.id">{{ item.travelTypeName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Submit To</mat-label>
            <mat-select formControlName="SubmitToList" multiple>
              <mat-select-trigger>
                {{getSubmitTypeNameByCode(form.controls.SubmitToList.value[0]) || ''}}
                @if ((form.controls.SubmitToList.value.length || 0) > 1) {
                  <span>
                    (+{{ (form.controls.SubmitToList.value.length || 0) - 1 }} {{ form.controls.SubmitToList.value.length === 2 ? 'other' : 'others' }})
                  </span>
                }
              </mat-select-trigger>

              <mat-option selectAll [allValues]="allSubmitToList()">Select all</mat-option>
              @for (item of submitToList(); track $index) {
                <mat-option [value]="item.submitToLinkCode">{{ item.submitToLink }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Issue Date From</mat-label>
            <input
              matInput
              readonly
              [matDatepicker]="picker"
              formControlName="IssueDateFrom"
            />
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker #picker/>
            @if (showIssueDateFromClearIcon) {
              <button
                matSuffix
                mat-icon-button
                (click)="resetFilter('IssueDateFrom')"
              >
                <mat-icon fontIcon="close"></mat-icon>
              </button>
            } @else {
              <mat-datepicker-toggle matIconSuffix [for]="picker"/>
            }
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Issue Date To</mat-label>
            <input
              matInput
              readonly
              [matDatepicker]="picker2"
              formControlName="IssueDateTo"
            />
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker #picker2/>
            @if (showIssueDateToClearIcon) {
              <button
                matSuffix
                mat-icon-button
                (click)="resetFilter('IssueDateTo')"
              >
                <mat-icon fontIcon="close"></mat-icon>
              </button>
            } @else {
              <mat-datepicker-toggle matIconSuffix [for]="picker2"/>
            }
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Data Sources</mat-label>
            <mat-select formControlName="DataSourceId">
              @for (item of tramsDataSource(); track $index) {
                <mat-option [value]="item.id">{{ item.sourceName }}</mat-option>
              }
            </mat-select>
            @if (showTramsDataSourceClearIcon) {
              <button
                matSuffix
                mat-icon-button
                (click)="resetFilter('DataSourceId')"
              >
                <mat-icon fontIcon="close"></mat-icon>
              </button>
            }
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Branches</mat-label>
            @if (branches().length) {
              <mat-select formControlName="BranchIds" multiple>
                <mat-select-trigger>
                  {{ getBranchNameById(form.controls.BranchIds.value[0]) || '' }}
                  @if ((form.controls.BranchIds.value.length || 0) > 1) {
                    <span>
                    (+{{ (form.controls.BranchIds.value.length || 0) - 1 }} {{ form.controls.BranchIds.value.length === 2 ? 'other' : 'others' }})
                  </span>
                  }
                </mat-select-trigger>

                <mat-option selectAll [allValues]="allBranches()">Select all</mat-option>
                @for (item of branches(); track $index) {
                  <mat-option [value]="item.id">{{ item.name }}</mat-option>
                }
              </mat-select>
            } @else {
              <mat-select formControlName="BranchIds">
                <mat-option [value]="[]">No Results</mat-option>
              </mat-select>
            }
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
